const GET_PENDING_ANNOUNCEMENT_ING = 'ANNOUNCEMENT/GET_PENDING_ING'
const GET_PENDING_ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT/GET_PENDING_SUCCESS'
const GET_PENDING_ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT/GET_PENDING_FAILURE'

const DISMISS_ANNOUNCEMENT_ING = 'ANNOUNCEMENT/DISMISS_ING'
const DISMISS_ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT/DISMISS_SUCCESS'
const DISMISS_ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT/DISMISS_FAILURE'

const VIEW_ANNOUNCEMENT_ING = 'ANNOUNCEMENT/VIEW_ING'
const VIEW_ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT/VIEW_SUCCESS'
const VIEW_ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT/VIEW_FAILURE'

const GET_ANNOUNCEMENTS_ING = 'ANNOUNCEMENT/GET_LIST_ING'
const GET_ANNOUNCEMENTS_SUCCESS = 'ANNOUNCEMENT/GET_LIST_SUCCESS'
const GET_ANNOUNCEMENTS_FAILURE = 'ANNOUNCEMENT/GET_LIST_FAILURE'

const CREATE_ANNOUNCEMENT_ING = 'ANNOUNCEMENT/CREATE_ING'
const CREATE_ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT/CREATE_SUCCESS'
const CREATE_ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT/CREATE_FAILURE'

const UPDATE_ANNOUNCEMENT_ING = 'ANNOUNCEMENT/UPDATE_ING'
const UPDATE_ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT/UPDATE_SUCCESS'
const UPDATE_ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT/UPDATE_FAILURE'

const REMOVE_ANNOUNCEMENT_ING = 'ANNOUNCEMENT/REMOVE_ING'
const REMOVE_ANNOUNCEMENT_SUCCESS = 'ANNOUNCEMENT/REMOVE_SUCCESS'
const REMOVE_ANNOUNCEMENT_FAILURE = 'ANNOUNCEMENT/REMOVE_FAILURE'

const CLEAR_PENDING_ANNOUNCEMENT = 'ANNOUNCEMENT/CLEAR_PENDING'

const defaultState = {
  pending: null,
  messageDetail: null,
  announcements: {
    count: 0,
    rows: []
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_PENDING_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        pending: action.payload || null
      }
    case GET_PENDING_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        pending: null
      }
    case VIEW_ANNOUNCEMENT_SUCCESS:
      if (!action.payload) {
        return state
      }
      return {
        ...state,
        messageDetail: action.payload
      }
    case VIEW_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        messageDetail: null
      }
    case GET_ANNOUNCEMENTS_SUCCESS:
      if (!action.payload) {
        return state
      }
      return {
        ...state,
        announcements: action.payload
      }
    case GET_ANNOUNCEMENTS_FAILURE:
      return {
        ...state,
        announcements: {
          count: 0,
          rows: []
        }
      }
    case 'AUTH/SIGNOUT_SUCCESS':
    case 'AUTH/SIGNOUT_FAILURE':
      return defaultState
    case CLEAR_PENDING_ANNOUNCEMENT:
      return {
        ...state,
        pending: null
      }
    default:
      return {...state}
  }
}

export const clearPendingAnnouncement = () => {
  return {
    type: CLEAR_PENDING_ANNOUNCEMENT
  }
}

export const getPendingAnnouncement = () => {
  return {
    types: [GET_PENDING_ANNOUNCEMENT_ING, GET_PENDING_ANNOUNCEMENT_SUCCESS, GET_PENDING_ANNOUNCEMENT_FAILURE],
    promise: (apiClient) => apiClient.get('/api/announcements/pending')
  }
}

export const dismissAnnouncement = ({announcementId}) => {
  return {
    types: [DISMISS_ANNOUNCEMENT_ING, DISMISS_ANNOUNCEMENT_SUCCESS, DISMISS_ANNOUNCEMENT_FAILURE],
    promise: (apiClient) => apiClient.post(`/api/announcements/${announcementId}/dismiss`)
  }
}

export const viewAnnouncement = ({announcementId}) => {
  return {
    types: [VIEW_ANNOUNCEMENT_ING, VIEW_ANNOUNCEMENT_SUCCESS, VIEW_ANNOUNCEMENT_FAILURE],
    promise: (apiClient) => apiClient.post(`/api/announcements/${announcementId}/view`)
  }
}

export const getAnnouncements = ({offset, limit}) => {
  return {
    types: [GET_ANNOUNCEMENTS_ING, GET_ANNOUNCEMENTS_SUCCESS, GET_ANNOUNCEMENTS_FAILURE],
    promise: (apiClient) => apiClient.get('/api/announcements', {params: {offset, limit}})
  }
}

export const createAnnouncement = ({title, summary, content, beginTime, endTime}) => {
  return {
    types: [CREATE_ANNOUNCEMENT_ING, CREATE_ANNOUNCEMENT_SUCCESS, CREATE_ANNOUNCEMENT_FAILURE],
    promise: (apiClient) => apiClient.post('/api/announcements', {title, summary, content, beginTime, endTime})
  }
}

export const updateAnnouncement = ({announcementId, title, summary, content, beginTime, endTime}) => {
  return {
    types: [UPDATE_ANNOUNCEMENT_ING, UPDATE_ANNOUNCEMENT_SUCCESS, UPDATE_ANNOUNCEMENT_FAILURE],
    promise: (apiClient) => apiClient.put(`/api/announcements/${announcementId}`, {title, summary, content, beginTime, endTime})
  }
}

export const removeAnnouncement = ({announcementId}) => {
  return {
    types: [REMOVE_ANNOUNCEMENT_ING, REMOVE_ANNOUNCEMENT_SUCCESS, REMOVE_ANNOUNCEMENT_FAILURE],
    promise: (apiClient) => apiClient.delete(`/api/announcements/${announcementId}`)
  }
}

export const publishAnnouncement = ({announcementId}) => {
  return {
    types: ['ANNOUNCEMENT/PUBLISH_ING', 'ANNOUNCEMENT/PUBLISH_SUCCESS', 'ANNOUNCEMENT/PUBLISH_FAILURE'],
    promise: (apiClient) => apiClient.post(`/api/announcements/${announcementId}/publish`)
  }
}

export const previewAnnouncement = ({announcementId}) => {
  return {
    types: ['ANNOUNCEMENT/PREVIEW_ING', 'ANNOUNCEMENT/PREVIEW_SUCCESS', 'ANNOUNCEMENT/PREVIEW_FAILURE'],
    promise: (apiClient) => apiClient.get(`/api/announcements/${announcementId}/preview`)
  }
}
